import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';
import { en, ptBR } from './locales/index';

// Parse language from Zustand persist storage or fallback to localStorage
const LanguageSchema = z.enum(['en', 'pt-BR']);

const getInitialLanguage = (): string => {
  const fallback = 'en';

  try {
    const uiStorage = localStorage.getItem('ui-storage');
    if (uiStorage) {
      const parsed: unknown = JSON.parse(uiStorage);
      if (
        typeof parsed === 'object' &&
        parsed !== null &&
        'state' in parsed &&
        typeof parsed.state === 'object' &&
        parsed.state !== null &&
        'language' in parsed.state &&
        LanguageSchema.safeParse(parsed.state.language).success
      ) {
        return LanguageSchema.parse(parsed.state.language);
      }
    }
    // Fallback to old localStorage key for backwards compatibility
    const oldLanguage = localStorage.getItem('language');
    if (oldLanguage) {
      const parsedLanguage = LanguageSchema.safeParse(oldLanguage);
      if (parsedLanguage.success) {
        return parsedLanguage.data;
      }
    }
  } catch {
    // Ignore parse errors
  }
  return fallback;
};

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: en.common,
      games: en.games,
      sessions: en.sessions,
      sidebar: en.sidebar,
    },
    'pt-BR': {
      common: ptBR.common,
      games: ptBR.games,
      sessions: ptBR.sessions,
      sidebar: ptBR.sidebar,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common', 'games', 'sessions', 'sidebar'],
  interpolation: {
    escapeValue: false,
  },
});

export { default } from 'i18next';
